<template>
  <PapeleriaReportsList/>
</template>
<script>
import PapeleriaReportsList from '@/components/modules/papeleria/reports/list'
export default {
  name: 'PapeleriaReports',
  components: {
    PapeleriaReportsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/reports/list.vue